export default __webpack_public_path__ + "static/media/suicide.150d25b2.png";